import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { Check } from "untitledui-js-base";

export type LeaseStatusBadgeProps = {
  status: "Current" | "Applicant" | "Notice";
};

export const LeaseStatusBadge = ({ status }: LeaseStatusBadgeProps) => {
  switch (status) {
    case "Current":
      return (
        <Badge
          leftElement={<Check className="stroke-success-700" size="12" />}
          size={BadgeSize.SM}
          variant={BadgeVariant.OUTLINE}
          className="flex items-center"
        >
          Active
        </Badge>
      );

    default:
      return (
        <Badge size={BadgeSize.SM} variant={BadgeVariant.OUTLINE}>
          {status}
        </Badge>
      );
  }
};
